// Plan de marquage Welyft v1 (16/06/2026), onglet « Events GA4 - Detailed funnel », section AE.
// Ne pas renommer : les déclencheurs des containers GTM-P6TNNF4 (prod) et GTM-5TNK6WN (staging) en dépendent.
// page_type / page_category absents à dessein : les containers les dérivent de tables Regex sur Page Path.
export const AeTrackingEvents = {
    funnelAccess: 'ae_funnel_access',
    coverage: 'ae_coverage',
    currentInsurer: 'ae_current_insurer',
    // Hors plan detailed funnel : emprunté à l'onglet consolidé, seul moyen de mesurer les 5 étapes du wizard.
    formProgress: 'ae_form_progress',
    leadGenerated: 'ae_lead_generated',
    leadGeneratedWarm: 'ae_lead_generated_warm',
    leadGeneratedHot: 'ae_lead_generated_hot',
    ctaInsurer: 'ae_cta_insurer',
    clickCall: 'ae_click_call',
    // Hors plan de marquage v1 : import IA de l'offre de prêt, tags GTM à créer avant MEP.
    pdfImportStart: 'ae_pdf_import_start',
    pdfImportSuccess: 'ae_pdf_import_success',
    pdfImportError: 'ae_pdf_import_error',
    pdfImportHelp: 'ae_pdf_import_help',
    pdfImportModeSwitch: 'ae_pdf_import_mode_switch',
    // Off the v1 tracking plan: pre-filled field reliability on the adhesion form, GTM tags to create before release.
    adhesionPrefilledFieldChange: 'ae_adhesion_prefilled_field_change',
    adhesionFormSubmitted: 'ae_adhesion_form_submitted',
} as const
